import React from "react";
//import { BackButton } from './App';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet"; //metadata manager
import { Button } from "../elements/buttons";
import { Benefits } from "../elements/headerComponents";
import { ProductsPromo } from "../elements/products";
import {
  Section,
  Image,
  ListGroup,
  ListItem
} from "../elements/bodyComponents";
import { SectionTitle, BodyCopy } from "../typography/typography";
import { RecipeCard } from "../elements/recipes";
import { SocialShare } from "../social/components";
import {
  ShowPage,
  HidePage,
  ScrollToPosition,
  BuildImagePath
} from "../helpers/helpers";

//styles
import "../css/products.css";
import "../css/backgrounds.css";

//data
import { Products } from "../json/products";
import { Recipes } from "../json/recipes";
import { Config } from "../json/config";
import {VideoLightbox} from "./videoPlayer";

/*
    Uses some of the same code from the RecipeDetail pages
*/
export class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.params = this.props.match.params;

    this.getProduct = this.getProduct.bind(this);
    this.playVideo = this.playVideo.bind(this);

    this.state = {
      product: this.getProduct(this.params.group, this.params.name),
      color: this.getColor(this.params.group),
        activeVideo: null
    };
  }

  /*
        Get Product
    */
  getProduct(group, name) {
    const groupItems = Products[group];
    return groupItems.items.find(p => {
      return p.id === name;
    });
  }

  getColor(group) {
    return Config.colors[group];
  }

  playVideo(){

      console.log(this);
      console.log(this.state.product.videoURL);
      let videoData = {
          videoURL: this.state.product.videoURL,
          videoID: "recipePlayer",
          controls: true,
          autoPlay: true,
      };

      console.log(videoData);

      this.setState({
          activeVideo: videoData
      });

  }

  /*
        called when new params are passed to the component, like changing between projects
    */
  componentWillReceiveProps(nextProps) {
      ScrollToPosition(0, "smooth");
      this.setState({
          activeVideo: null,
          color: this.getColor(nextProps.match.params.group),
          product: this.getProduct(
              nextProps.match.params.group,
              nextProps.match.params.name
          )
      });

  }

  componentWillUnmount() {
    if (
      document.querySelector(".globalHeader").classList.contains("shrinkLogo")
    ) {
      document.querySelector(".globalHeader").classList.remove("shrinkLogo");
    }
    HidePage();
  }

  /*
        called when component first loads, not called for changes
    */
  componentDidMount() {
    //force logo into small layout
    const header = document.querySelector(".globalHeader");
    if (header.classList.contains("shrinkLogo") === false) {
      header.classList.add("shrinkLogo");
    }
    document
      .querySelector(".globalNav")
      .setAttribute("data-activepage", this.params.group);


    ShowPage();
  }

  render() {
    const product = this.state.product;
    const recipes = [];
    let recipeItems = [];

    if (this.params.group !== "mealKits") {
      if(product.recipes.length ){

      }
      for (let r of product.recipes) {
        const matchedRecipe = Recipes.filter(recipe => {
          return recipe.id === r;
        });
        if (matchedRecipe.length > 0) {
          recipes.push(matchedRecipe[0]);
        }
      }

      recipeItems = recipes.map(r => (
        <RecipeCard
          key={r.id}
          type="recipe"
          id={r.id}
          color={this.state.color}
          title={typeof r.shortname !== "undefined" ? r.shortname : r.name}
          description={r.description}
          image={r.image}
        />
      ));
    }

    let mealKitContents = [];
    let mealKitPurchase = [];
    if (this.params.group === "mealKits") {
      mealKitContents = product.contents.map((c, index) => (
        <ListItem
          key={`mealKitContents_${index}`}
          classes="mealKit-items color-gray"
        >
          <p className="mealKit-items-title uppercase focus">{c.title}</p>
          {typeof c.content !== "undefined" &&
                        <p className="mealKit-items-content">{ c.content }</p>
                    }
        </ListItem>
      ));
      mealKitPurchase = product.purchase.map((c, index) => (
        <ListItem
          key={`mealKitPurchase_${index}`}
          classes="mealKit-items color-gray"
        >
          <p className="mealKit-items-content">{c}</p>
        </ListItem>
      ));
    }

    const imageSizeArray = [
      {
        w: 480,
        name: "small"
      },
      {
        w: 4000,
        name: "large"
      }
    ];

    console.log(`Is Mobile: ${window.isMobile}.  Hide header left:${product.hideHeaderLeft}`);

    return (
      <div
        className="layout-productDetail usingMasterCard usingBackgrounds"
        data-type={this.params.group}
        data-product={product.id}
        ref={el => (this.page = el)}
      >
          { this.state.activeVideo !== null && <VideoLightbox activeVideo={this.state.activeVideo}/> }
        <Helmet>
          <title>{`${Config.title} - ${product.name}`}</title>
          <meta name="og:title" content={`${product.name}`} />
          <meta name="og:description" content={product.description} />
          <meta name="og:image" content={product.image.full} />
          <meta property="og:url" content={window.location.href} />
        </Helmet>
        <header className="pageHeader noHeader">
          <div className="header-background">
            <img
              className="left"
              src={BuildImagePath(
                `${this.params.group}_${product.id}_left.png`,
                "headers",
                imageSizeArray
              )}
              alt=""
            />
            <img
              className="right"
              src={BuildImagePath(
                `${this.params.group}_${product.id}_${
                  product.useSameBackgrounds === true ? "left.png" : "right.png"
                }`,
                "headers",
                imageSizeArray
              )}
              alt=""
            />
          </div>
        </header>

        <Section classes="recipe-detail width-medium masterCard mobileBorder">
          <Link to={`/products/${this.params.group}`}>
            <Button classes="button-back textOnly" />
          </Link>

          <div className="recipe-row-top flex vertical-center padding-y-large padding-x-large">
            <Image
              src={product.image.full}
              classes="product-image margin-right-large"
              alt={product.name}
            />
            <div className="recipe-description color-gray">
              <SectionTitle classes="">{product.name}</SectionTitle>
              <BodyCopy classes="margin-top-medium font-helvetica">
                {product.description}
              </BodyCopy>
              <div className={"flex"}>
                <SocialShare
                  classes="margin-top-small"
                  color={this.state.color}
                  image={product.image.full}
                  pageType="product"
                  title={product.name}
                  desc={product.description}
                />
                <div className={"margin-top-medium mealKit-time recipe-info-component text-align-center color-gray prep"}>
                  <h4 className={"cardTitle uppercase"}>Ready Under</h4>
                  <p className={"recipe-info-value"}>
                    <span className={"value"}>30</span>
                    <span className={"units"}>mins</span>
                  </p>
                </div>
              </div>
                {typeof product.videoURL !== "undefined" && (
              <div className={"flex watchVideoButton"}>
                  <button
                      className="watchVideo"
                      onClick={this.playVideo}
                  >
                      Watch video for instructions
                      <div style={{width: "2em", alignSelf: "center" }}>
                          <img src={"/img/playIcon.png"}/>
                      </div>
                  </button>
              </div>
                )}
            </div>

            {this.params.group === "mealKits" && (
              <div className="meal-kit-contents color-gray">
                <div className="whatYouGet flex">
                  <div>
                    <h4 className="cardTitle uppercase margin-bottom-small color-gray">
                      What&apos;s Inside
                    </h4>
                    <ListGroup classes="margin-left-large">
                      {mealKitContents}
                    </ListGroup>
                  </div>
                  {window.isMobile === false && (
                    <div>
                      <img src={product.image.top} />
                    </div>
                  )}
                </div>
                <div className="whatYouNeed margin-top-large flex">
                  <div>
                    <h4 className="cardTitle uppercase margin-bottom-small color-gray">
                      What You Need
                    </h4>
                    <ListGroup classes="margin-left-large">
                      {mealKitPurchase}
                    </ListGroup>
                  </div>
                  {window.isMobile === false && (
                    <div>
                      <img src={product.image.bottom} />
                    </div>
                  )}
                </div>
              </div>
            )}
            {this.params.group !== "mealKits" &&  (
              <div className="related-recipes color-gray">
                  {product.recipes.length > 0 &&
                  <h3 className="sectionTitle uppercase margin-top-xsmall text-align-center font-louisana color-gray-medium">
                      Recipes
                  </h3>
                  }
                  {
                      product.recipes.length > 0 &&
                      <div className="flex">{recipeItems}</div>
                  }
              </div>
            )}
          </div>

          <div className="recipe-row-bottom flex margin-top-medium color-gray padding-y-large padding-x-large">
            <div className="product-nutrition flex-grow padding-x-medium">
              <h4 className="cardTitle uppercase margin-bottom-medium dash-below dash-gray-light dash-large">
                Nutrition
              </h4>
              <Nutrition data={product.nutrition} />
              <p className="tiny color-gray-medium font-helvetica margin-top-medium">
                *Percent Daily Values are based on a 2,000 calorie diet.
              </p>
            </div>
            <div className="product-ingredients padding-x-medium">
              <Benefits classes="margin-bottom-large" />
              <h4 className="cardTitle uppercase margin-bottom-medium dash-below dash-gray-light dash-large">
                Ingredients
              </h4>
              <p className="font-helvetica tiny">{product.ingredients}</p>
              {typeof product.allergy !== "undefined" && (
                <p className="font-helvetica tiny bold">
                  Contains: {product.allergy}
                </p>
              )}
            </div>
          </div>
        </Section>

        <ProductsPromo
          category={this.params.group}
          color={this.state.color}
          max="4"
          currentProduct={product.id}
          title={`More ${this.params.group}`}
          classes="width-medium masterCard margin-top-large margin-bottom-large padding-x-xlarge"
          URL={`/products/${this.params.group}`}
        />
      </div>
    );
  }
}

class Nutrition extends React.Component {
  render() {
    const n = this.props.data;
    console.log(n);
    return (
      <div className="nutrition-grid font-helvetica">
        <div className="nutrition-group servings">
          <div className="nutrition-row noBorder">
            <p className="nutrition-key bold">Serving Size</p>
            {typeof n.servingSize.tbsp !== "undefined" && (
              <p className="nutrition-value">
                {n.servingSize.tbps} Tbps ({n.servingSize.g}g)
              </p>
            )}
            {typeof n.servingSize.oz !== "undefined" && (
              <p className="nutrition-value">
                {n.servingSize.oz}oz ({n.servingSize.g}g)
              </p>
            )}
          </div>
          <div className="nutrition-row noBorder">
            <p className="nutrition-key bold">Servings Per Container</p>
            <p className="nutrition-value">{n.servings}</p>
          </div>
        </div>
        <div className="nutrition-group amount-intro">
          <div className="nutrition-row noBorder">
            <div className="nutrition-row-left">
              <p className="bold">Amount Per Serving</p>
            </div>
            {n.showPrepared === true && (
              <div className="nutrition-row-right">
                <p className="bold">Packaged</p>
                <p className="bold">Prepared</p>
              </div>
            )}
          </div>
        </div>
        <div className="nutrition-group calories">
          {n.showPrepared === true && (
            <div>
              <div className="nutrition-row">
                <div className="nutrition-row-left">
                  <p className="nutrition-key bold">Calories</p>
                </div>
                <div className="nutrition-row-right">
                  <p className="nutrition-value">{n.calories.base}</p>
                  <p className="nutrition-value">{n.calories.basePrep}</p>
                </div>
              </div>
              <div className="nutrition-row">
                <div className="nutrition-row-left">
                  <p className="nutrition-key">Calories from Fat</p>
                </div>
                <div className="nutrition-row-right">
                  <p className="nutrition-value">{n.calories.fat}</p>
                  <p className="nutrition-value">{n.calories.fatPrep}</p>
                </div>
              </div>
            </div>
          )}
          {n.showPrepared !== true && (
            <div className="nutrition-row">
              <div className="nutrition-row-left">
                <p className="nutrition-key bold">Calories</p>
                <p className="nutrition-value">{n.calories.base}</p>
              </div>
              <div className="nutrition-row-right">
                <p className="nutrition-key">Fat Cal.</p>
                <p className="nutrition-value">{n.calories.fat}</p>
              </div>
            </div>
          )}
        </div>
        <div className="nutrition-group daily-value">
          <div className="nutrition-row noBorder">
            <div className="nutrition-row-right">
              <p className="nutrition-key bold">% Daily Value*</p>
            </div>
          </div>
        </div>
        <div className="nutrition-group fat">
          <div className="nutrition-row total-fat">
            <div className="nutrition-row-left">
              <p className="nutrition-key bold">Total Fat</p>
              <p className="nutrition-value">{n.fat.total.g}g</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.fat.total.percent}</span>%
              </p>
              {typeof n.fat.total.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.fat.total.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
          <div className="nutrition-row sat-fat">
            <div className="nutrition-row-left">
              <p className="nutrition-key">Sat. Fat</p>
              <p className="nutrition-value">{n.fat.sat.g}g</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.fat.sat.percent}</span>%
              </p>
              {typeof n.fat.sat.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.fat.sat.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
          <div className="nutrition-row trans-fat">
            <div className="nutrition-row-left">
              <p className="nutrition-key">Trans Fat</p>
              <p className="nutrition-value">{n.fat.trans.g}g</p>
            </div>
          </div>
        </div>
        <div className="nutrition-group cholesterol">
          <div className="nutrition-row">
            <div className="nutrition-row-left">
              <p className="nutrition-key bold">Cholest.</p>
              <p className="nutrition-value">{n.cholesterol.mg}mg</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.cholesterol.percent}</span>%
              </p>
              {typeof n.cholesterol.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.cholesterol.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="nutrition-group sodium">
          <div className="nutrition-row">
            <div className="nutrition-row-left">
              <p className="nutrition-key bold">Sodium</p>
              <p className="nutrition-value">{n.sodium.mg}mg</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.sodium.percent}</span>%
              </p>
              {typeof n.sodium.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.sodium.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="nutrition-group carbs">
          <div className="nutrition-row total-carbs">
            <div className="nutrition-row-left">
              <p className="nutrition-key bold">Total Carb.</p>
              <p className="nutrition-value">{n.carbs.total.g}g</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.carbs.total.percent}</span>%
              </p>
              {typeof n.carbs.total.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.carbs.total.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
          <div className="nutrition-row fiber">
            <div className="nutrition-row-left">
              <p className="nutrition-key">Fiber</p>
              <p className="nutrition-value">{n.carbs.fiber.g}g</p>
            </div>
            <div className="nutrition-row-right">
              <p className="nutrition-value">
                <span className="bold">{n.carbs.fiber.percent}</span>%
              </p>
              {typeof n.carbs.fiber.percentPrep !== "undefined" && (
                <p className="nutrition-value">
                  <span className="bold">{n.carbs.fiber.percentPrep}</span>%
                </p>
              )}
            </div>
          </div>
          <div className="nutrition-row sugar">
            <div className="nutrition-row-left">
              <p className="nutrition-key">Sugars</p>
              <p className="nutrition-value">{n.carbs.sugar.g}g</p>
            </div>
          </div>
        </div>
        <div className="nutrition-group protein">
          <div className="nutrition-row">
            <div className="nutrition-row-left">
              <p className="nutrition-key bold">Protein</p>
              <p className="nutrition-value">{n.protein.g}g</p>
            </div>
          </div>
        </div>
        <div className="nutrition-group vitamins">
          {n.showPrepared === true && (
            <div>
              <div className="nutrition-row">
                <div className="nutrition-row-left">
                  <p className="nutrition-key">Vitamin A</p>
                </div>
                <div className="nutrition-row-right">
                  <p className="nutrition-value">{n.vitamin.a}%</p>
                  {typeof n.vitamin.aPrep !== "undefined" && (
                    <p className="nutrition-value">{n.vitamin.aPrep}%</p>
                  )}
                </div>
              </div>
              <div className="nutrition-row">
                <div className="nutrition-row-left">
                  <p className="nutrition-key">Vitamin C</p>
                </div>
                <div className="nutrition-row-right">
                  <p className="nutrition-value">{n.vitamin.c}%</p>
                  {typeof n.vitamin.cPrep !== "undefined" && (
                    <p className="nutrition-value">{n.vitamin.cPrep}%</p>
                  )}
                </div>
              </div>
              <div className="nutrition-row">
                <div className="nutrition-row-left">
                  <p className="nutrition-key">Calcium</p>
                </div>
                <div className="nutrition-row-right">
                  <p className="nutrition-value">{n.vitamin.calcium}%</p>
                  {typeof n.vitamin.calciumPrep !== "undefined" && (
                    <p className="nutrition-value">{n.vitamin.calciumPrep}%</p>
                  )}
                </div>
              </div>
                {typeof n.vitamin.iron !== "undefined" && (
                    <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Iron</p>
                        </div>
                        <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.iron}%</p>
                            {typeof n.vitamin.ironPrep !== "undefined" && (
                                <p className="nutrition-value">{n.vitamin.ironPrep}%</p>
                            )}
                        </div>
                    </div>)
                }
            </div>
          )}
          {n.showPrepared !== true && (
            <div>
                  {
                      typeof n.vitamin.a !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Vitamin A</p>
                        </div>
                        <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.a}%</p>
                        </div>
                      </div>
                  }
                  {
                      typeof n.vitamin.c !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Vitamin C</p>
                        </div>
                          <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.c}%</p>
                        </div>
                      </div>
                  }
                  {
                      typeof n.vitamin.d !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Vitamin D</p>
                        </div>
                          <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.d}%</p>
                        </div>
                      </div>
                  }
                  {
                      typeof n.vitamin.calcium !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Calcium</p>
                        </div>
                          <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.calcium}%</p>
                        </div>
                      </div>
                  }
                  {
                      typeof n.vitamin.iron !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Iron</p>
                        </div>
                          <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.iron}%</p>
                        </div>
                      </div>
                  }
                  {
                      typeof n.vitamin.potassium !== "undefined" &&
                      <div className="nutrition-row">
                        <div className="nutrition-row-left">
                            <p className="nutrition-key">Potassium</p>
                        </div>
                          <div className="nutrition-row-right">
                            <p className="nutrition-value">{n.vitamin.potassium}%</p>
                        </div>
                      </div>
                  }
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/product.js